import {CLEAR_DAILY_REPORTS, CLEAR_LOADING, FETCH_DAILY_REPORTS, LIST_DAILY_REPORTS,} from "./types";

const init = {
    isLoading: false,
    data: null,
    filter: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_DAILY_REPORTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_DAILY_REPORTS:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_DAILY_REPORTS:
            return {
                ...init
            };
        case CLEAR_LOADING:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}